import { AuthPageLayout as AuthPageLayoutLib } from '@round/auth';
import { ReactComponent as Logo } from '../../../../assets/Logo.svg';
import brandingImage from '../../assets/AuthBackground.png';
import styles from './AuthPageLayout.module.css';
import { FCWithChildren } from '../../../../App.types';

const AuthPageLayout: FCWithChildren = ({ children }) => (
    <AuthPageLayoutLib LogoFull={() => <Logo className={styles.logoFull} />} brandingImageSrc={brandingImage}>
        {children}
    </AuthPageLayoutLib>
);

export default AuthPageLayout;
